import {
    Component,
    ComponentFactoryResolver,
    EventEmitter,
    Injector,
    Input,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ActivatedRoute, Router} from '@angular/router';
import {RequestApiService} from 'src/app/services/domain_code/request-api.service';
import {LeaseQuoteModel} from '../quotation-table/quote.model';
import {CommonService} from 'src/app/common.service';
import {QuillEditorComponent} from 'ngx-quill';
import {of, Subject} from 'rxjs';
import {LeaseQuoteTableService} from '../quoteTable/lease-quote-table/lease-quote-table.service';
import {ApiRoutes} from 'src/app/services/apiroutes';
import {BackendListModel} from 'src/app/models/common/list.model';
import {DomainCode} from 'src/app/models/common/model';
import {DomainCodeApiService} from 'src/app/services/domain_code/domain-code-api.service';
import {DropoffSchedule, PickupSchedule} from '../quoteTable/lease-quote-table/lease-quote';
import {LeaseDocuments, LeaseRemarksList} from 'src/app/models/lease-quote';
import {environment} from 'src/environments/environment';
import {DocumentModel} from 'src/app/models/document';
import {
    PickupDropoffScheduleLeaseComponent
} from '../pickup-dropoff-schedule-lease/pickup-dropoff-schedule-lease.component';
import {
    SendEmailConfirmationComponent
} from '../../dialog-box/send-email-confirmation/send-email-confirmation.component';
import {MatDialog} from '@angular/material/dialog';
import {FailureBoxComponent} from '../../dialog-box/failure-box/failure-box.component';
import {WarningBoxComponent} from '../../dialog-box/warning-box/warning-box.component';

@Component({
    selector: 'logzy-lease-review-quotation',
    templateUrl: './lease-review-quotation.component.html',
    styleUrls: ['./lease-review-quotation.component.scss']
})
export class LeaseReviewQuotationComponent implements OnInit {
    constructor(public requestService: RequestApiService,
        private route: ActivatedRoute, private router: Router,
        private snackBar: MatSnackBar, public commonService: CommonService,
        public leaseQuoteService: LeaseQuoteTableService,
        private domainService: DomainCodeApiService,
        private dialog: MatDialog,
        private resolver: ComponentFactoryResolver,
        private injector: Injector) {
    }
    requestType: string;
    requestId: string;
    @Input() commercials;
    quoteObj: LeaseQuoteModel = new LeaseQuoteModel();
    @Input()
    negotiate: boolean = false;
    isEditable: boolean = false;
    leaseDetailsExpand: boolean = true;
    currentDate = new Date();
    leaseAgreementDuration: string = null;
    fromDays: number;
    toDays: number;
    @ViewChild('editor', { static: false }) editor: QuillEditorComponent;
    baseQuote: any;
    leaseReview = new Subject<boolean>();
    remarks: string;
    disableSaveButton: boolean = false;
    @Output()
    closeReview = new EventEmitter();
    @Output()
    backToQuote = new EventEmitter();
    @Input()
    reviewLease;
    @Input()
    reviewing: boolean = false;
    @Input()
    HeaderSet: boolean = true;

    downloadUrl = ApiRoutes.LeadRequest;

    dd_leaseOptions: any;
    dd_leaseUse: BackendListModel<DomainCode>;
    remarksList: LeaseRemarksList[] = [];

    base_url = environment.baseApiUrl;
    displayedColumns: string[] = ['original_filename', 'document_size', 'document_type', 'created_by'];

    lease_quote_for_post = {};
    lease_quote_for_review = {};
    agreementPayload = [];
    quoteItemsPayload = [];
    pickupSchedulePayload: PickupSchedule[];
    dropoffSchedulePayload: DropoffSchedule[];
    scheduleListP: PickupSchedule[] = [];
    scheduleListD: DropoffSchedule[] = [];

    documentTypeList: LeaseDocuments[] = [];
    selectedDocument: LeaseDocuments = null;
    selectedDocumentType: string = "";
    uploadedDocuments: DocumentModel[] = [];
    showUpload: boolean = false;
    chargeMasterPayload = [];
    quoteChargeMasterPayload = [];
    location_url: string = `${ApiRoutes.Location}?location_type_name=port&search=::search::`;
    containerSizeTypeUrl = `${ApiRoutes.ContainerMaster}container_size_type/?search=::search::`
    editQuantity=false;
    editTerms=false;

    @Input()
    bookingDetails;
    @ViewChild(PickupDropoffScheduleLeaseComponent) pickupDropoffScheduleLeaseComponent: PickupDropoffScheduleLeaseComponent;

    ngOnInit(): void {
        if (this.reviewing == true) {
            this.leaseDetailsExpand = true;
        }
        if (this.HeaderSet == false) {
            this.leaseDetailsExpand = true;
        }
        this.baseQuote = LeaseQuoteModel;
        console.log("Check ERO", this.commercials.lease_agreement);
        // this.commercials.lease_agreement = this.requestService.selectedAgreementDetails;
        console.log("reviewLease", this.commercials)
        console.log("this.requestService.selectedRequest?.status?.dev_name", this.requestService.selectedRequest?.status?.dev_name)
        if (this.commercials?.quote_items.length != 0) {
            this.commercials.quote_items.map(quote => {
                if (quote.ero.length != 0) {
                    var count = 1;
                    quote.ero.map(ero => {
                        ero.fromDays = count;
                        ero.toDays = ero.fromDays + ero.days;
                        count = ero.toDays + 1;
                    })
                }
            })
        }

        this.commercials.quote_items.map(item => {
            if (item.ero?.length == 0)
                item.is_ero_enabled = false;
            else
                item.is_ero_enabled = true;
        });
        this.commonService.quotationData = this.commercials;
        // console.log("main hu Bharti", this.commercials);
        // console.log("requestService.selectedRequest.request_type", this.requestService.selectedRequest);
        this.route.queryParams.subscribe(params => {
            if ('id' in params || 'type' in params || 'rtype' in params) {
                this.requestId = params['id'];
                this.getLeaseUse();
                this.leaseAgreementOptions(this.requestId);
            }
        });

        if (this.commercials.lease_agreement.agreement_ends_on !== null && this.commercials.lease_agreement.agreement_starts_from != null) {
            const date1: Date = new Date(this.commercials.lease_agreement.agreement_ends_on);
            const date2: Date = new Date(this.commercials.lease_agreement.agreement_starts_from);

            const timeDifferenceMs: number = date1.getTime() - date2.getTime();
            const differenceInDays: number = Math.floor(timeDifferenceMs / (1000 * 60 * 60 * 24));

            this.leaseAgreementDuration = differenceInDays + ' Days';

        }

        if (this.commercials.uploaded_documents.length != 0) {
            this.showUpload = true;
        }

        this.getAllData();
        this.getRemarksList();
        this.getDocumentTypeList();
        this.scrolltop();
        // console.log("this.requestService.selectedAgreementDetails", this.requestService.selectedAgreementDetails)

    }

    getRemarksList() {
        this.requestService.getRemarksList(this.requestId).subscribe(res => {
            this.remarksList = res.results;
        })
    }

    getDocumentTypeList() {
        this.requestService.getDocumentTypeList('lease_quote').subscribe(res => {
            this.documentTypeList = res.results;
        })
    }

    readableFileSize(size) {
        var units = ['B', 'KB', 'MB'];
        var i = 0;
        while (size >= 1024) {
            size /= 1024;
            ++i;
        }
        return size?.toFixed(2) + ' ' + units[i];
    }

    showDocumentUpload(event) {
        this.selectedDocument = event;
        if (this.selectedDocument != null) {
            this.selectedDocumentType = this.selectedDocument.dev_name;
            this.showUpload = true;
        } else {
            this.showUpload = false;
        }
    }

    scrolltop() {
        console.log("on top ")
        console.log("document.querySelector('#top')", document.querySelector("#top"));
        console.log("document.getElementById('top')", document.getElementById("top"));
        setTimeout(() => {
            document.getElementById("top")?.scrollIntoView({ block: "start", behavior: "smooth" });
        }, 200);
    }

    saveQuotation() {
        console.log(this.commercials);

        this.lease_quote_for_post = [];

        this.getReviewAgreementPayload();
        this.getQuoteSavePayload();
        this.getSchedulePayload();
        this.lease_quote_for_post = {
            ad_hoc_charges: this.commercials.ad_hoc_charges,
            quote_items: this.quoteItemsPayload,
            lease_agreement: this.agreementPayload[0],
            pickup_schedules: this.pickupSchedulePayload,
            dropoff_schedules: this.dropoffSchedulePayload,
            quote_valid_till: this.commercials.quote_valid_till,
            remarks: this.commercials.remarks,
            terms_and_condition_text: this.commercials.terms_and_condition_text,
            terms_and_condition_fk: this.commercials.terms_and_condition_fk,
            request: this.requestId,
            uploaded_documents: this.commercials.uploaded_documents
        }
        console.log(this.lease_quote_for_post);

        // this.requestService.postQuotations(this.lease_quote_for_post).subscribe({
        //   next: response => {
        //     this.snackBar.open('Quotations saved', 'Close', {
        //       verticalPosition: 'top',
        //       duration: 3000,
        //     });
        //     this.disableSaveButton = false;
        //     return response;
        //   },
        //   error: error => {
        //     this.disableSaveButton = false;
        //     return this.catchError(error);
        //   }
        // });
    }

    saveQuote() {
        console.log(this.commercials);

        this.lease_quote_for_post = [];
        this.chargeMasterPayload = [];

        this.getReviewAgreementPayload();
        this.getQuoteSavePayload();
        this.getSchedulePayload();

        if (this.commercials.ad_hoc_charges.length != 0) {
            this.commercials.ad_hoc_charges.map(charge => {
                this.chargeMasterPayload.push({
                    quote_charge: charge.quote_charge.id,
                    amount: charge.amount,
                    amount_currency: charge.amount_currency
                });
            })
        }

        this.lease_quote_for_post = {
            ad_hoc_charges: this.chargeMasterPayload,
            quote_items: this.quoteItemsPayload,
            lease_agreement: this.agreementPayload[0],
            pickup_schedules: this.pickupSchedulePayload,
            dropoff_schedules: this.dropoffSchedulePayload,
            quote_valid_till: this.commercials.quote_valid_till,
            remarks: this.commercials.remarks,
            terms_and_condition_text: this.commercials.terms_and_condition_text,
            terms_and_condition_fk: this.commercials.terms_and_condition_fk,
            request: this.requestId,
            uploaded_documents: this.commercials.uploaded_documents ? this.commercials.uploaded_documents.map(item => item.id) : []
        }
        console.log(this.lease_quote_for_post);


        this.requestService.postQuotations(this.lease_quote_for_post).subscribe({
            next: response => {
                this.snackBar.open('Quotations saved', 'Close', {
                    verticalPosition: 'top',
                    duration: 3000,
                });
                this.disableSaveButton = false;
                this.openSendQuoteConfirmationDialog(response['id'], 'lease', 'Quote email sent', 'quote');
                return response;
            },
            error: error => {
                this.disableSaveButton = false;
                this.catchError(error);
                this.closeReview.emit(false);
            }
        });
    }

    openSendQuoteConfirmationDialog(quoteId, type, snackBarMessage, mailType): void {
        let htmlContent: string = '';
        this.requestService.getQuoteContentForEmail(quoteId, type, mailType).subscribe(
            (response: string) => {
                htmlContent = response;
                const dialogData = {
                    usersList: [this.requestService.selectedRequest.requestor?.email],
                    userListKey: '',
                    contentURL: ApiRoutes.QuoteConfirmEmailUrl,
                    contentKeys: {
                        to_emails: '',
                        subject: (mailType == 'quote' ? 'Quote is ready for Request No: ' : 'Booking Confirmed for Request No: ') + this.requestService.selectedRequest.request_number,
                        content: htmlContent
                    },
                    mailType: mailType,
                    snackBarMessage: snackBarMessage

                };
                const dialogRef = this.dialog.open(SendEmailConfirmationComponent, {
                    width: '80%', // Set the width of the dialog
                    disableClose: true,
                    data: dialogData
                });

                dialogRef.afterClosed().subscribe(result => {
                    if (result) {
                        console.log('User clicked Yes');
                        this.disableSaveButton = false;
                    } else {
                        this.disableSaveButton = false;
                    }
                    window.location.reload();
                });

                dialogRef.componentInstance.emailSend.subscribe(() => {
                    window.location.reload();
                    // this.closeReview.emit(true);
                });
            },
            (error) => {
                console.error('Error fetching HTML content:', error);
            }
        );
    }

    getReviewAgreementPayload() {
        this.agreementPayload = [];
        var lease_purpose = null, lease_type = null, billing_cycle = null, billing_date = null;

        // if (this.requestDetails.lease_agreement.lease_purpose != null) {
        //   if (this.requestDetails.lease_agreement.lease_purpose instanceof Object)
        //     lease_purpose = this.requestDetails.lease_agreement.lease_purpose.id;
        //   else
        //     lease_purpose = this.dd_leaseUse ? this.dd_leaseUse?.results.filter(item => item.dev_value == (this.requestDetails.lease_agreement.lease_purpose ? this.requestDetails.lease_agreement.lease_purpose.dev_value : null)).map(item => item.id)[0] : null;

        // }
        // if (this.requestDetails.lease_agreement.lease_type != null) {
        //   if (this.requestDetails.lease_agreement.lease_type instanceof Object)
        //     lease_type = this.requestDetails.lease_agreement.lease_type.value;
        //   else
        //     lease_type = this.dd_leaseOptions?.actions?.POST?.lease_type.choices.filter(item => item.display_name == this.requestDetails.lease_agreement.lease_type).map(item => item.value)[0];

        // }
        // if (this.requestDetails.lease_agreement.billing_cycle != null) {
        //   if (this.requestDetails.lease_agreement.billing_cycle instanceof Object)
        //     billing_cycle = this.requestDetails.lease_agreement.billing_cycle.value;
        //   else
        //     billing_cycle = this.dd_leaseOptions?.actions?.POST?.billing_cycle.choices.filter(item => item.display_name == this.requestDetails.lease_agreement.billing_cycle).map(item => item.value)[0];

        // }
        // if (this.requestDetails.lease_agreement.billing_date != null) {
        //   if (this.requestDetails.lease_agreement.billing_date instanceof Object)
        //     billing_date = this.requestDetails.lease_agreement.billing_date.value;
        //   else
        //     billing_date = this.dd_leaseOptions?.actions?.POST?.billing_date.choices.filter(item => item.display_name == this.requestDetails.lease_agreement.billing_date).map(item => item.value)[0];

        // }

        this.agreementPayload.push({
            id: this.requestService.selectedRequest.lease_agreement.id,
            lease_purpose: this.commercials.lease_agreement.lease_purpose != null ? this.commercials.lease_agreement.lease_purpose.id : null,
            lease_type: this.commercials.lease_agreement.lease_type != null ? this.commercials.lease_agreement.lease_type.value : null,
            billing_cycle: this.commercials.lease_agreement.billing_cycle != null ? this.commercials.lease_agreement.billing_cycle.value : null,
            billing_date: this.commercials.lease_agreement.billing_date != null ? this.commercials.lease_agreement.billing_date.value : null,
            security_deposit_currency: this.commercials.lease_agreement.security_deposit_currency,
            security_deposit: this.commercials.lease_agreement.security_deposit,
            agreement_number: this.commercials.lease_agreement.agreement_number,
            agreement_starts_from: this.commercials.lease_agreement.agreement_starts_from,
            agreement_ends_on: this.commercials.lease_agreement.agreement_ends_on,
            currency: this.commercials.lease_agreement.currency,
            remarks: this.commercials.lease_agreement.remarks,
            lessor_company_name: this.commercials.lease_agreement.lessor_company_name,
            lessor_contact_person_name: this.commercials.lease_agreement.lessor_contact_person_name,
            lessor_contact_person_email: this.commercials.lease_agreement.lessor_contact_person_email,
            lessor_contact_person_phone: this.commercials.lease_agreement.lessor_contact_person_phone,
            lessee_company_name: this.commercials.lease_agreement.lessee_company_name,
            lessee_contact_person_name: this.commercials.lease_agreement.lessee_contact_person_name,
            lessee_contact_person_email: this.commercials.lease_agreement.lessee_contact_person_email,
            lessee_contact_person_phone: this.commercials.lease_agreement.lessee_contact_person_phone,
            lessor_company_address: this.commercials.lease_agreement.lessor_company_address,
            lessee_company_address: this.commercials.lease_agreement.lessee_company_address,
            request: this.requestId
        });
    }

    getSchedulePayload() {
        this.pickupSchedulePayload = [];
        this.dropoffSchedulePayload = [];

        this.scheduleListP = this.commercials.pickup_schedules;
        this.scheduleListD = this.commercials.dropoff_schedules;

        // console.log('getSchedulePayload', this.scheduleListP);
        // console.log('getSchedulePayload', this.scheduleListD);

        this.scheduleListP.map(pickup => {
            pickup.client_id = pickup.id;
            if (pickup.port instanceof Object)
                pickup.port = pickup.port.id;
            if (pickup.requirement instanceof Object)
                pickup.requirement = pickup.requirement.id;
            this.pickupSchedulePayload.push(pickup);
        });

        this.scheduleListD.map(dropoff => {
            dropoff.client_id = dropoff.id;
            if (dropoff.port instanceof Object)
                dropoff.port = dropoff.port.id;
            if (dropoff.requirement instanceof Object)
                dropoff.requirement = dropoff.requirement.id;
            this.dropoffSchedulePayload.push(dropoff);
        });
    }

    getQuoteSavePayload() {
        this.quoteItemsPayload = [];
        this.commercials.quote_items.map(quote => {
            this.quoteChargeMasterPayload = [];
            quote.ero.map(ero => {
                ero.penalty_from = ero.penalty_from instanceof Object ? ero.penalty_from.value : ero.penalty_from;
            });

            if (quote.ad_hoc_charges.length != 0) {
                quote.ad_hoc_charges.map(charge => {
                    this.quoteChargeMasterPayload.push({
                        quote_charge: charge.quote_charge.id,
                        amount: charge.amount,
                        amount_currency: charge.amount_currency
                    });
                })
            }

            this.quoteItemsPayload.push({
                ad_hoc_charges: this.quoteChargeMasterPayload,
                requirement: quote.requirement,
                container_size_type: quote.container_size_type,
                per_diem_charge: quote.per_diem_charge,
                per_diem_charge_currency: quote.per_diem_charge_currency,
                leasing_period_days: quote.leasing_period_days,
                container_condition: quote.container_condition ? quote.container_condition.id : null,
                pol_list: quote.pol_list ? quote.pol_list.map((item) => item.id) : [],
                pod_list: quote.pod_list ? quote.pod_list.map((item) => item.id) : [],
                build_up_period_days: quote.build_up_period_days,
                build_down_period_days: quote.build_down_period_days,
                post_build_down_per_diem_charge: quote.post_build_down_per_diem_charge,
                minimum_rental_period_days: quote.minimum_rental_period_days,
                post_build_down_per_diem_charge_currency: quote.post_build_down_per_diem_charge_currency,
                container_deemed_lost_after_days: quote.container_deemed_lost_after_days,
                notice_period_amendment_delivery_days: quote.notice_period_amendment_delivery_days,
                notice_period_amendment_return_days: quote.notice_period_amendment_return_days,
                drv_new_build_price: quote.drv_new_build_price,
                drv_new_build_price_currency: quote.drv_new_build_price_currency,
                drv_max_depreciation_price: quote.drv_max_depreciation_price,
                drv_max_depreciation_price_currency: quote.drv_max_depreciation_price_currency,
                drv_max_depreciation_unit: quote.drv_max_depreciation_unit,
                drv_depreciation_per_year: quote.drv_depreciation_per_year,
                drv_max_depreciation_percent: quote.drv_max_depreciation_percent,
                quantity: quote.quantity,
                is_ero_enabled: quote.is_ero_enabled instanceof Object ? quote.is_ero_enabled.code == true ? true : false : quote.is_ero_enabled,
                ero: quote.is_ero_enabled instanceof Object ? quote.is_ero_enabled.code == true ? quote.ero : [] : quote.is_ero_enabled == true ? quote.ero : []
            })
        });
    }

    // catchError(error) {
    //     if (error.status >= 500) {
    //         this.quoteObj.error = { ...error.error };
    //         return error;
    //     } else if (error.status > 399 && error.status < 500) {
    //         this.quoteObj.error = { ...error.error };
    //         return error;
    //     }
    // }

    getAllData() {
        if (this.commercials.lease_agreement != null) {
            if (this.commercials?.lease_agreement.lease_type != null) {
                switch (this.commercials.lease_agreement.lease_type) {
                    case 'operational_lease': {
                        this.commercials.lease_agreement.lease_type = 'Operational Lease';
                        break;
                    }
                    case 'financial_lease': {
                        this.commercials.lease_agreement.lease_type = 'Financial Lease';
                        break;
                    }
                    default:
                        break;
                }
            }
            if (this.commercials?.lease_agreement.billing_cycle != null) {
                switch (this.commercials.lease_agreement.billing_cycle) {
                    case 'yearly': {
                        this.commercials.lease_agreement.billing_cycle = 'Yearly';
                        break;
                    }
                    case 'quarterly': {
                        this.commercials.lease_agreement.billing_cycle = 'Quarterly';
                        break;
                    }
                    case 'monthly': {
                        this.commercials.lease_agreement.billing_cycle = 'Monthly';
                        break;
                    } case 'half_yearly': {
                        this.commercials.lease_agreement.billing_cycle = 'Half Yearly';
                        break;
                    }
                    default:
                        break;
                }
            }
            if (this.commercials?.lease_agreement.billing_date != null) {
                switch (this.commercials?.lease_agreement.billing_date.toString()) {
                    case '1': {
                        this.commercials.lease_agreement.billing_date = '1st of every month';
                        break;
                    }
                    case '5': {
                        this.commercials.lease_agreement.billing_date = '5th of every month';
                        break;
                    }
                    case '7': {
                        this.commercials.lease_agreement.billing_date = '7th of every month';
                        break;
                    }
                    case '10': {
                        this.commercials.lease_agreement.billing_date = '10th of every month';
                        break;
                    }
                    default:
                        break;
                }
            }

            if (this.commercials.lease_agreement.agreement_ends_on !== null && this.commercials.lease_agreement.agreement_starts_from != null) {
                const date1: Date = new Date(this.commercials.lease_agreement.agreement_ends_on);
                const date2: Date = new Date(this.commercials.lease_agreement.agreement_starts_from);

                const timeDifferenceMs: number = date1.getTime() - date2.getTime();
                const differenceInDays: number = Math.floor(timeDifferenceMs / (1000 * 60 * 60 * 24));

                this.leaseAgreementDuration = differenceInDays + ' Days';

            }

            this.commercials.lease_agreement.currency = 'USD';
        }
    }
    convertoAgreementObj() {
        if (this.requestService.selectedRequest?.status?.dev_name == 'counter_quote_by_internal_user') {

        }
    }
    getOptionsData() {
        switch (this.commercials.lease_agreement.lease_type) {
            case 'Operational Lease': {
                this.commercials.lease_agreement.lease_type = 'operational_lease';
                break;
            }
            case 'Financial Lease': {
                this.commercials.lease_agreement.lease_type = 'financial_lease';
                break;
            }
            default:
                break;
        }


        switch (this.commercials.lease_agreement.billing_cycle) {
            case 'Yearly': {
                this.commercials.lease_agreement.billing_cycle = 'yearly';
                break;
            }
            case 'Quarterly': {
                this.commercials.lease_agreement.billing_cycle = 'quarterly';
                break;
            }
            case 'Monthly': {
                this.commercials.lease_agreement.billing_cycle = 'monthly';
                break;
            } case 'Half Yearly': {
                this.commercials.lease_agreement.billing_cycle = 'half_yearly';
                break;
            }
            default:
                break;
        }

        switch (this.commercials.lease_agreement.billing_date) {
            case '1st of every month': {
                this.commercials.lease_agreement.billing_date = '1';
                break;
            }
            case '5th of every month': {
                this.commercials.lease_agreement.billing_date = '5';
                break;
            }
            case '7th of every month': {
                this.commercials.lease_agreement.billing_date = '7';
                break;
            }
            default:
                break;
        }
    }

    leaseAgreementOptions(reqId) {
        this.requestService.optionsLeaseAgreement(this.requestId).subscribe(response => {
            this.dd_leaseOptions = response;
        })
    }

    getLeaseUse() {
        this.domainService.getByGroup('ContainerPurpose').subscribe(response => {
            this.dd_leaseUse = response;
        })
    }

    getAgreementPayload() {
        this.agreementPayload.push({
            id: this.requestService.selectedRequest.lease_agreement.id,
            lease_purpose: this.commercials.lease_agreement.lease_purpose ? this.commercials.lease_agreement.lease_purpose.id : null,
            lease_type: this.commercials.lease_agreement.lease_type ? this.commercials.lease_agreement.lease_purpose.id : null,
            billing_cycle: this.commercials.lease_agreement.billing_cycle ? this.commercials.lease_agreement.lease_purpose.id : null,
            billing_date: this.commercials.lease_agreement.billing_date ? this.commercials.lease_agreement.lease_purpose.id : null,
            security_deposit_currency: this.commercials.lease_agreement.security_deposit_currency,
            security_deposit: this.commercials.lease_agreement.security_deposit,
            agreement_number: this.commercials.lease_agreement.agreement_number,
            agreement_starts_from: this.commercials.lease_agreement.agreement_starts_from,
            agreement_ends_on: this.commercials.lease_agreement.agreement_ends_on,
            currency: this.commercials.lease_agreement.currency,
            remarks: this.commercials.lease_agreement.remarks,
            lessor_company_name: this.commercials.lease_agreement.lessor_company_name,
            lessor_contact_person_name: this.commercials.lease_agreement.lessor_contact_person_name,
            lessor_contact_person_email: this.commercials.lease_agreement.lessor_contact_person_email,
            lessor_contact_person_phone: this.commercials.lease_agreement.lessor_contact_person_phone,
            lessee_company_name: this.commercials.lease_agreement.lessee_company_name,
            lessee_contact_person_name: this.commercials.lease_agreement.lessee_contact_person_name,
            lessee_contact_person_email: this.commercials.lease_agreement.lessee_contact_person_email,
            lessee_contact_person_phone: this.commercials.lease_agreement.lessee_contact_person_phone,
            lessor_company_address: this.commercials.lease_agreement.lessor_company_address,
            lessee_company_address: this.commercials.lease_agreement.lessee_company_address,
            request: this.requestId
        });
    }

    //Updated code of Confirm Booking using Lease service
    bookingConfirmed() {
        this.disableSaveButton = true;
        console.log("this.disableSaveButton", this.disableSaveButton);
        if (this.requestService.selectedRequest.request_type.dev_name == 'lease') {
            this.saveQuotation();
            if(this.pickupSchedulePayload.length!=-0 || this.dropoffSchedulePayload.length!=0){
            // of(this.leaseQuoteService.confirmBooking(this.lease_quote_for_post, this.remarks)).subscribe(res => {
            //     this.leaseQuoteService.review.subscribe(item => {
            //         this.disableSaveButton = false;
            //         console.log("this.disableSaveButton", this.disableSaveButton);
            //         if (item == null) return;
            //         if (item == false) {
            //             this.closeReview.emit(false);
            //         }
            //     });
            // });
            of(this.leaseQuoteService.confirmBooking(this.lease_quote_for_post, this.remarks))
                .subscribe({
                    next: (res) => {
                        this.leaseQuoteService.review.subscribe(item => {
                            this.disableSaveButton = false;
                            console.log("this.disableSaveButton", this.disableSaveButton);
                            if (item == null) return;
                            if (item == false) {
                                this.closeReview.emit(false);
                            }
                        });
                    },
                    error: (error) => {
                        console.log("error", error);

                        if ('requestor' in error.error) {
                            let label = 'Customer KYC Pending';
                            let desc = '';
                            error.error.requestor.forEach(item => {
                                desc += `• ${item}\n`;
                            });
                            this.openDialogOnError(label, desc);
                        } else 
                        if ('sales_person' in error.error && 'billing_entity' in error.error) {
                            const message = `Please update the below details to proceed further:<br><br>• Sales Person<br>• Billing Entity`;
                            this.openWarning(message, '', 'Ok');
                            } else if ('sales_person' in error.error) {
                                this.openWarning('Enter the sales person name to proceed further.', '', 'Ok');
                            } else if ('billing_entity' in error.error) {
                                this.openWarning('Enter the billing entity to proceed further.', '', 'Ok');
                            }
                        this.closeReview.emit(false);
                    }
                });
            }
            else{
                this.openWarning('pickup and drop-off schedule are required to confirm the booking', '', 'Ok');
            }
        }
    }

    downloadQuote(quote: LeaseQuoteModel) {
        window.open(this.downloadUrl + 'request_quotes/pdf/lease/' + quote.id + '/', '_blank')
    }

    back() {
        this.leaseQuoteService.type = 'confirm';
        this.backToQuote.emit();
    }
    openDialogOnError(label, description) {
        const dialogRef = this.dialog.open(FailureBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: { subTitle: label, description: description }
        });

        dialogRef.afterClosed().subscribe(item => {
            let baseUrl = window.location.href.replace(this.router.url, '');
            window.open(`${baseUrl}/master-data/customer-master?id=${this.requestService.selectedRequest.requestor?.company?.id}`, '_blank')
            this.closeReview.emit(false);
        })
    }
    openWarning(label: string, description, action1: string, action2?: string) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: { subTitle: label, parent: this, description: description, label1: action1, label2: action2 }
        });
    }
    postBookingLocation(requirement,i) {
        let payload = {
            pol_list: requirement.pol_list.map(item => item?.id),
            pod_list: requirement.pod_list.map(item => item?.id)
        }
        this.requestService.updateBookingLocation(requirement.id, payload).subscribe({
            next: response => {
                requirement.editPOL = false
                requirement.editPOD = false

                this.snackBar.open("Location Updated Successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
            },
            error: err => {
                return this.catchError(err, requirement);
            }
        })
    }
    errorObj: any = {};

    catchError(error,requirement?) {
        const errorData = { ...error.error };
        if (error.status >= 500) {
            this.quoteObj.error = {...error.error};
            this.errorObj = {...error.error};
            return error;
        } else if (error.status > 399 && error.status < 500) {
            if (requirement) {
                this.errorObj = this.errorObj || {};
                this.errorObj[requirement.id] = {
                    ...this.errorObj[requirement.id],
                    ...errorData
                };
                return error;
            }
            else{
            this.quoteObj.error = {...error.error};
            this.errorObj = {...error.error};
            return error;
            }
        }
    }
    postBookingQuantity(requirement) {
        let payload={
            quantity : requirement.quantity
        }
        this.requestService.updateBookingQuantity( requirement.id, payload).subscribe({
            next: response => {
                requirement.editQuantity = false
                this.snackBar.open("Quantity Updated Successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
            },
            error: err => {
                return this.catchError(err,requirement);
            }
        })
    }

    postContainerSizeType(requirement) {
        let payload={
            container_size_type : requirement.container_size_type ? requirement.container_size_type?.id : null
        }
        this.requestService.updateContainerSizeType( requirement.id,payload).subscribe({
            next: response => {
                requirement.editContainerSizeType = false
                this.snackBar.open("Sized Type Updated Successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
            },
            error: err => {
                return this.catchError(err,requirement);
            }
        })
    }

    saveRequirement(quote) {

        if (quote.editQuantity) {
            this.postBookingQuantity(quote);
        }
        if (quote.editContainerSizeType) {
            this.postContainerSizeType(quote);
        }
    }

    reset(booking,i) {
        booking.editQuantity = false;
        booking.editContainerSizeType = false;
        booking.editPOL = false;
        booking.editPOD = false;
    }
}
